<template>
  <ion-button
    v-if="procedureCount > 0"
    :aria-label="$t('modals.procedures')"
    @click="openProcedures"
  >
    <ion-icon slot="icon-only" :icon="icons.helpBuoyOutline"></ion-icon>
  </ion-button>
</template>

<script>
import { IonButton, IonIcon, modalController } from '@ionic/vue';
import { helpBuoyOutline } from 'ionicons/icons';

import ODNModalProjectProcedures from '@m/odn-modal-project-procedures.vue';

import APIService from '@s/api.service';

// Toolbar button listing the procedures of a project in a modal. Hidden when
// the project has no procedure visible to the user.
export default {
  name: 'ODNProceduresButton',
  components: {
    IonButton,
    IonIcon,
  },
  props: {
    projectId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      procedureCount: 0,
      icons: {
        helpBuoyOutline,
      },
    };
  },
  watch: {
    projectId: {
      handler() {
        this.fetchCount();
      },
      immediate: true,
    },
  },
  methods: {
    async fetchCount() {
      if (!this.projectId) {
        this.procedureCount = 0;
        return;
      }

      try {
        const response = await APIService.get(
          `/projects/${this.projectId}/procedures`,
          { page: 1, limit: 1 }
        );
        this.procedureCount = response.data.meta.totalItems;
      } catch (err) {
        // Keep the button hidden, the form remains usable
        this.procedureCount = 0;
      }
    },
    async openProcedures() {
      const modal = await modalController.create({
        component: ODNModalProjectProcedures,
        componentProps: {
          projectId: this.projectId,
        },
      });
      await modal.present();
    },
  },
};
</script>
